/* eslint-disable */
import girl1 from "../assets/svg/testimonials/girl1.svg";
import girl2 from "../assets/svg/testimonials/girl2.svg";
import girl3 from "../assets/svg/testimonials/girl3.svg";
import boy1 from "../assets/svg/testimonials/boy1.svg";
import boy2 from "../assets/svg/testimonials/boy2.svg";
import boy3 from "../assets/svg/testimonials/boy3.svg";

export const testimonialsData = [
  {
    id: 1,
    name: "Nate Umber",
    title: "US Client(upwork)",
    text: "This freelancer did his job quickly and efficiently. Always in touch, polite, and customer-oriented. Thank you for a great job! We recommend this specialist.",
    image: girl1,
  },
  {
    id: 2,
    name: "Samishta ",
    title: "Tech Marketing(angellist)",
    text: "A rare combination of technology with management skills. Passionate & aspirational to develop new skills to become better equipped individual.",
    image: girl2,
  },
  {
    id: 3,
    name: "Heryad Serkewt",
    title: "User(youtube)",
    text: "finally found good video on youtube thanks,  but for next time please fix your audio",
    image: boy3,
  },
  {
    id: 4,
    name: "Aakash Nishad ",
    title: "User(youtube)",
    text: "Hey, man, Thanks for this tutorial. Is there any thing like recycleview android studio, to show data in list.",
    image: boy1,
  },
  {
    id: 5,
    name: "LashmarMedia",
    title: "User(youtube)",
    text: "You are a STAR thank you for the very easy to follow step by step guide in this complex matter. THANK YOU!!!",
    image: boy2,
  },
  //   {
  //     id: 6,
  //     name: "Ross Geller",
  //     title: "Paleontologist",
  //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
  //     image: boy3,
  //   },
];
